<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between align-items-center">
    <a class="nav-item fw-bold brand p-1" [routerLink]="['/']" routerLinkActive="router-link-active">
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <img alt="" class="home-logo" [src]="'logos/rewards-logo.png' | contentAssetImage" draggable="false" />
    </a>

    <div class="mobile-right-nav">
      <ng-container *notInPopulation="[populations.TicketTransfer]">
        <fgb-notification-button></fgb-notification-button>
      </ng-container>
      <button class="nav-item fw-bold navbar-toggler m-0 px-2" (click)="isCollapsed = !isCollapsed">
        <span class="icon material-icons material-mobile-nav">menu</span>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown">
    <div class="d-flex flex-column mobile-nav-menu-content">
      <a class="fw-bold" [routerLink]="['/']" routerLinkActive="router-link-active">
        <label id="homeLink" class="accessibility-only">Go To Home Page</label>
        <img alt="" class="inner-logo" [src]="'logos/rewards-logo.png' | contentAssetImage" draggable="false" />
      </a>
      <!-- Close Button -->
      <button
        class="close-button position-absolute border-0 transparent"
        attr.aria-label="{{ 'modal.close' | translate }}"
        (click)="isCollapsed = !isCollapsed"
      >
        <i class="material-icons text-white close-btn">close</i>
      </button>

      <!-- Nav Buttons -->
      <div class="mobile-nav-button-container pt-3">
        <ng-container *notInPopulation="[populations.TicketTransfer]">
          <a
            class="nav-item"
            [routerLink]="['/account']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="d-flex align-items-center">
              <i class="material-symbols-outlined">account_circle</i>
              <div class="nav-text fw-bold font-size-14">{{ 'nav.account' | translate }}</div>
            </div>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/rewards']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="d-flex align-items-center">
              <i class="material-symbols-outlined">redeem</i>
              <div class="nav-text fw-bold font-size-14">{{ 'nav.rewards' | translate }}</div>
            </div>
          </a>
          <a
            class="nav-item"
            [routerLink]="['/challenges']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="d-flex align-items-center">
              <i class="material-symbols-outlined">trophy</i>
              <div class="nav-text fw-bold font-size-14">{{ 'nav.challenges' | translate }}</div>
            </div>
          </a>

          <!-- <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
            <ng-container *inPopulation="[populations.Default]">
              <a
                class="nav-item"
                [routerLink]="['/offers']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="d-flex align-items-center">
                  <i class="material-symbols-outlined">percent_discount</i>
                  <div class="nav-text fw-bold font-size-14">{{ 'nav.offer' | translate }}</div>
                </div>
              </a>
            </ng-container>
          </ng-container> -->
          <a class="nav-item" [routerLink]="['/games']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <div class="d-flex align-items-center">
              <i class="material-symbols-outlined">sports_esports</i>
              <div class="nav-text fw-bold font-size-14">{{ 'nav.games' | translate }}</div>
            </div>
          </a>
          <a
            class="nav-item"
            [routerLink]="['/rewards/wallet']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="d-flex align-items-center">
              <i class="material-symbols-outlined">account_balance_wallet</i>
              <div class="nav-text fw-bold font-size-14">{{ 'nav.wallet' | translate }}</div>
            </div>
          </a>

          <ng-container *notInPopulation="[populations.U18]">
            <a
              class="nav-item"
              [routerLink]="['/earn']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="d-flex align-items-center">
                <i class="material-symbols-outlined">loyalty</i>
                <div class="nav-text fw-bold font-size-14">{{ 'nav.earn' | translate }}</div>
              </div>
            </a>
          </ng-container>

          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.gallery'">
            <a
              class="nav-item"
              [routerLink]="['/gallery']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="d-flex align-items-center">
                <i class="material-symbols-outlined">animated_images</i>
                <div class="nav-text fw-bold font-size-14">
                  {{ 'nav.worksheet.gallery' | translate }}
                </div>
              </div>
            </a>
          </ng-container>

          <div class="help-wrapper">
            <div class="help-dropdown">
              <span class="material-symbols-outlined">info</span>
              <span class="nav-text">{{ 'nav.help' | translate }}</span>
              <span class="material-icons arrow">expand_more</span>
            </div>

            <div class="help-submenu">
              <a
                class="nav-item"
                [routerLink]="['/terms']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="d-flex align-items-center">
                  <div class="nav-text fw-bold font-size-14">{{ 'nav.terms' | translate }}</div>
                </div>
              </a>
              <a
                class="nav-item"
                [routerLink]="['/faq']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="d-flex align-items-center">
                  <div class="nav-text fw-bold font-size-14">{{ 'nav.faq' | translate }}</div>
                </div>
              </a>

              <a
                class="nav-item"
                [routerLink]="['/contact']"
                [routerLinkActive]="'active'"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <div class="d-flex align-items-center">
                  <div class="nav-text fw-bold font-size-14">{{ 'nav.contact.us' | translate }}</div>
                </div>
              </a>
            </div>
          </div>
        </ng-container>

        <a class="log-out" data-bs-dismiss="offcanvas" (click)="logout()">
          <i class="material-icons font-size-14 fw-bold">logout</i>
          <div>{{ 'nav.log.out' | translate }}</div>
        </a>
      </div>
    </div>
  </div>
</div>
